import app from "/src/app/app.module";


app.config(['$translateProvider', function ($translateProvider) {
    $translateProvider.translations('nl-nl', {
        FUTURE_JOBS: 'Klussen komende 7 dagen',
        INCOMING_ORDERS: 'Binnengekomen orders afgelopen 14 dagen',
        REVENUE_STATUS: "Omzet per job status inzichtelijk",
        REVENUE_STATUS_ORDERS: "Omzet per order status inzichtelijk",
        STATUS_JOBS_MONTHLY: "Status van jobs per maand",
        STATUS_ORDERS_MONTHLY: "Status van order per maand",
        STATUS_JOBS_THIS_MONTH: "Status van jobs deze maand",
        STATUS_ORDERS_THIS_MONTH: "Status van jobs deze maand",
        HOME: 'Home',
        DASHBOARD: 'Dashboard',
        NETHERLANDS: 'Nederland',
        BELGIUM: 'België',
        FRANCE: 'Frankrijk',
        GERMANY: 'Duitsland',
        LUXEMBOURG: 'Luxemburg',
        ITALY: 'Italië',
        STATS: 'Stats',
        OPEN_DASHBOARD: 'Naar dashboard',
        USER_RESPONDS: 'Personeelsreactie',
        USER_RESPONDS_DESC: 'Het User Response Dashboard biedt inzicht in hoe gebruikers omgaan met taaktoewijzingen. Het houdt belangrijke statistieken bij, zoals geaccepteerde, wachtende, geweigerde en niet-beantwoorde taken. Daarnaast toont het de gemiddelde en mediane reactietijd, het responspercentage en andere KPI\'s.',
        JOB_TYPE_FILTER: 'Taaktype filter',
        JOB_TYPE_FILTER_DESC: 'Het Job Type Gefilterd Dashboard biedt inzicht in taakstatistieken gegroepeerd op taaktype. Het geeft een overzicht van het totale aantal taken, geaccepteerde, wachtende en geweigerde taken per type, inclusief gemiddelde reactietijden en trends over tijd.',
        BUSY_PERIODS: 'Drukke periodes',
        BUSY_PERIODS_DESC: 'Het Drukke Periodes Dashboard toont wanneer de drukste momenten zijn per maand. Het bevat een grafiek met maandelijkse drukte en een heatmap per maand die de drukste dagen visualiseert. Alleen geaccepteerde opdrachten worden meegenomen.',
         FINANCIAL_DASHBOARD: 'Financieel overzicht',
         FINANCIAL_DASHBOARD_DESC: 'Het Financieel Dashboard toont omzet en taakstatistieken per bedrijf. Het bevat omzet per taakstatus (optie, bevestigd, geannuleerd), het aantal taken per maand en de verdeling van taakstatussen voor de huidige maand.',
         PRODUCT_DASHBOARD: 'Product Analytics Dashboard',
         PRODUCT_DASHBOARD_DESC: 'Het Product Analytics Dashboard biedt inzicht in de verkoop van alle producten per groep. Het toont hoeveelheden, gemiddelde verkopen per taak, inkomsten, en de top 3 best verkochte producten met gedetailleerde productanalyse.',
         NOTIFICATIONS: 'Notificaties'
    });

    const translations = {
        OPEN_DASHBOARD: 'To dashboard',
        USER_RESPONDS: 'User Response',
        USER_RESPONDS_DESC: 'The User Response Dashboard provides insights into how users interact with job assignments. It tracks key metrics such as accepted, awaiting, declined, and unresponded jobs. Additionally, it shows the average and median response times, response rate, and other KPIs.',
        JOB_TYPE_FILTER: 'Job Type Filter',
        JOB_TYPE_FILTER_DESC: 'The Job Type Filtered Dashboard provides insights into job statistics grouped by job type. It shows an overview of total jobs, accepted, awaiting, and declined jobs per type, including average response times and trends over time.',
        BUSY_PERIODS: 'Busy Periods',
        BUSY_PERIODS_DESC: 'The Busy Periods Dashboard shows when the busiest moments are per month. It includes a chart with monthly busyness and a heatmap per month visualizing the busiest days. Only accepted jobs are included.',
         FINANCIAL_DASHBOARD: 'Financial Overview',
         FINANCIAL_DASHBOARD_DESC: 'The Financial Dashboard shows revenue and job statistics per company. It includes revenue per job status (option, confirmed, canceled), job counts per month, and the distribution of job statuses for the current month.',
         PRODUCT_DASHBOARD: 'Product Analytics Dashboard',
         PRODUCT_DASHBOARD_DESC: 'The Product Analytics Dashboard provides insights into product sales across all product groups. It shows quantities, average sales per job, revenue, and the top 3 best-selling products with detailed product analysis.',
         FUTURE_JOBS: 'Jobs next 7 days',
        INCOMING_ORDERS: 'Received orders past 14 days',
        REVENUE_STATUS: "Revenue breakdown by job status",
        REVENUE_STATUS_ORDERS: "Revenue breakdown by order status",
        STATUS_JOBS_MONTHLY: "Status of jobs each month",
        STATUS_JOBS_THIS_MONTH: "Status of jobs this month",
        STATUS_ORDERS_MONTHLY: "Status of jobs each month",
        STATUS_ORDERS_THIS_MONTH: "Status of jobs this month",
        HOME: 'Home',
        DASHBOARD: 'Dashboard',
        STATS: 'Stats',
        NETHERLANDS: 'Netherlands',
        BELGIUM: 'Belgium',
        FRANCE: 'France',
        GERMANY: 'Germany',
        LUXEMBOURG: 'Luxembourg',
        ITALY: 'Italy',
        NOTIFICATIONS: 'Notifications'
    };

    $translateProvider.translations('en-gb', translations);
    $translateProvider.translations('en-us', translations);

    $translateProvider.preferredLanguage('nl-nl');
}]);